module.exports = __webpack_public_path__ + "static/media/rudating.9e5ffccc.png";